<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent
      icono-titulo="fas fa-dollar-sign"
      texto-titulo="Anular comprobante"
    ></TituloComponent>
    <div class="main-card mb-3 card col-12">
      <div class="card-body">
        <form @submit.prevent="() => false">
          <div class="row">
            <FloatLabel label="Número" clase="offset-md-3 col-md-2 col-12">
              <input
                v-model="numero"
                id="numero"
                inputmode="numeric"
                placeholder="Número"
                type="text"
                class="form-control"
              />
            </FloatLabel>
            <FloatLabel label="Tipo" clase="col-md-2 col-12">
              <select id="tipo" class="form-control" v-model="tipo">
                <option value="null">Seleccione</option>
                <option value="A">A</option>
                <option value="B">B</option>
                <option value="R">R</option>
              </select>
            </FloatLabel>
            <div class="col-md-2 col-12">
              <button
                type="button"
                @click="buscarComprobante"
                class="btn btn-info btn-block"
              >
                Buscar
              </button>
            </div>
            <template v-if="movimiento.id">
              <h4 class="w-100 text-center">{{ movimiento.denominacion }}</h4>
              <h4 class="w-100 text-center">{{ movimiento.cliente.nombre }}</h4>
              <h4 class="w-100 text-center text-success">
                ${{ movimiento.total || numFormat("0,0.00") }}
              </h4>
              <div class="col-12 col-md-6 text-center">
                <button type="button" @click="anularDefinitivo" class="mt-3 btn btn-info">Anular Definitivamente
                </button>
              </div>
              <div class="col-12 col-md-6 text-center">
                <button type="button" @click="anularYReactivar" class="mt-3 btn btn-success">Anular y reactivar pedido
                </button>
              </div>
            </template>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import BlockUI from "@/components/loaders/BlockUI";
import FloatLabel from "@/components/layouts/FloatLabel";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "AnularComprobante",
  components: {
    TituloComponent,
    FloatLabel,
    BlockUI,
  },
  data() {
    return {
      movimiento: {},
      tipo: null,
      numero: null,
      loading: false,
      enviado: false,
    };
  },
  mounted() {
  },
  methods: {
    anularDefinitivo() {
      this.movimiento.definitivo = true;
      this.anularMovimiento()
    },
    anularYReactivar() {
      this.movimiento.definitivo = false;
      this.anularMovimiento()
    },
    anularMovimiento() {
      this.enviado = true;
      this.loading = true;
      this.movimiento.user_id = this.$store.state.auth.user.id;
      axios
        .post("/movimientos/anular", this.movimiento)
        .then((res) => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `Se anuló con éxito.`,
            });

            this.numero = null;
            this.tipo = null;
            this.movimiento = {};
            document.getElementById("numero").focus();
          } else {
            Swal.fire({
              icon: "error",
              title: "Oopss..",
              text: `${res.mensaje}`,
            });
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`,
          });
        })
        .finally(() => (this.loading = false));
    },
    buscarComprobante() {
      if (isNaN(this.numero)) {
        Swal.fire({
          icon: "error",
          title: "Oopss..",
          text: `Debe ingresar el número.`,
        });
        return false;
      }
      if (this.tipo == null) {
        Swal.fire({
          icon: "error",
          title: "Oopss..",
          text: `Debe ingresar el tipo.`,
        });
        return false;
      }
      this.loading = true;
      let denominacion = `${this.tipo}${this.numero.padStart(8, "0")}`;
      axios
        .get("movimientos/buscar/" + denominacion)
        .then((res) => {
          if (res.data.success) {
            this.movimiento = res.data.movimiento;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oopss..",
              text: `No se ha encontrado el artículo.`,
            });
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha encontrado el artículo.`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    calcularNuevoStock() {
      if (isNaN(parseFloat(this.stock_entrante))) {
        this.stock_actualizado = parseFloat(this.articulo.stock) + 0;
      } else {
        this.stock_actualizado =
          parseFloat(this.articulo.stock) + parseFloat(this.stock_entrante);
      }
    },
  },
};
</script>
